<template>
  <div class="kw-spinner" />
</template>

<script>
export default {
  name: 'KwSpinner',
};
</script>

<style lang="scss">
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.kw-spinner {
  display: inline-block;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  vertical-align: middle;
  border-top-color: transparent;
  animation: spin .75s infinite linear;
}
</style>



// WEBPACK FOOTER //
// src/components/UI/KwSpinner.vue